var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1d0701ce25757333145fac4c9206f96a.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5399ec4721ff88da9e382843c4ee2f50.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb53989051a426365c90a1529a0d71bc.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    